import store from './store'
import localforage from 'localforage'
import IndexPage from './pages/index'
import StoreGroupPage from './pages/store-groups'
import MenuPage from './pages/menu'
import DiningPreferencePage from './pages/dining-preference'
import AboutPage from './pages/about'
import InfoPage from './pages/info'
import ItemPage from './pages/item'
import ContentAdjustmentPage from './pages/content-adjustment'
import OrdersPage from './pages/order'
import LinePayConfirmPage from './pages/line-pay-confirm'
import LinePayFailedPage from './pages/line-pay-failed'
import PaymentPage from './pages/payment'
import CheckboxSheet from './pages/modals/checkbox-sheet'
import NumberGroupSheet from './pages/modals/number-group-sheet'
import HistoryPage from './pages/history'
import NotFoundPage from './pages/not-found.vue'
import PanelLeftPage from './pages/panel-left'
import PanelRightPage from './pages/panel-right'
import SpecialRequestsPopup from './pages/modals/special-requests-popup'
import DeleteItemActions from './pages/modals/delete-item-actions'
import PhoneNumberPrompt from './pages/prompts/phone-number-prompt'
import TaxIdPrompt from './pages/prompts/tax-id-prompt'
import InvoiceTitlePrompt from './pages/prompts/invoice-title-prompt'
import ReceiptCarrierIdPrompt from './pages/prompts/receipt-carrier-id-prompt'

const withInit = component => async function (routeTo, routeFrom, resolve, reject) {
  if (store.getters.storeId) {
    resolve(component)
  } else {
    reject()
    const menuVariation = await localforage.getItem(`stores/${routeTo.params.storeIdPathParam}/menuVariation`)
    if (menuVariation === 'main' || !menuVariation) {
      this.navigate(`/stores/${routeTo.params.storeIdPathParam}/menu`, { reloadAll: true })
    } else {
      this.navigate(`/stores/${routeTo.params.storeIdPathParam}/menus/${menuVariation}`, { reloadAll: true })
    }
  }
}

export default [{
  path: '/',
  component: IndexPage
}, {
  path: '/panel-left',
  component: PanelLeftPage
}, {
  path: '/panel-right',
  component: PanelRightPage
}, {
  path: '/store-groups/:storeGroupIdPathParam',
  component: StoreGroupPage
}, {
  path: '/stores/:storeIdPathParam/menu',
  component: MenuPage
}, {
  path: '/stores/:storeIdPathParam/menus/:menuVariationPathParam',
  component: MenuPage
}, {
  path: '/stores/:storeIdPathParam/dining-preference',
  async: withInit({ sheet: { component: DiningPreferencePage } })
}, {
  path: '/stores/:storeIdPathParam/about',
  async: withInit({ component: AboutPage })
}, {
  path: '/stores/:storeIdPathParam/info',
  async: withInit({ component: InfoPage })
}, {
  path: '/stores/:storeIdPathParam/items/:itemIdPathParam',
  async: withInit({ component: ItemPage })
}, {
  path: '/stores/:storeIdPathParam/items/:itemBucketPathParam/:fullItemIdPathParam/questions',
  async: withInit({ component: ContentAdjustmentPage })
}, {
  path: '/stores/:storeIdPathParam/items/:itemBucketPathParam/:fullItemIdPathParam/questions/special-requests-popup',
  async: withInit({ popup: { component: SpecialRequestsPopup } })
}, {
  path: '/stores/:storeIdPathParam/items/:itemBucketPathParam/:fullItemIdPathParam/questions/:questionIdPathParam/checkbox-sheet',
  async: withInit({ sheet: { component: CheckboxSheet } })
}, {
  path: '/stores/:storeIdPathParam/items/:itemBucketPathParam/:fullItemIdPathParam/questions/:questionIdPathParam/number-group-sheet',
  async: withInit({ sheet: { component: NumberGroupSheet } })
}, {
  path: '/stores/:storeIdPathParam/items/:itemBucketPathParam/:itemIdPathParam/delete-item-actions',
  async: withInit({ actions: { component: DeleteItemActions } })
}, {
  path: '/stores/:storeIdPathParam/order',
  async: withInit({ component: OrdersPage })
}, {
  path: '/stores/:storeIdPathParam/order/phone-number-prompt',
  async: withInit({ popover: { component: PhoneNumberPrompt } })
}, {
  path: '/stores/:storeIdPathParam/order/tax-id-prompt',
  async: withInit({ popover: { component: TaxIdPrompt } })
}, {
  path: '/stores/:storeIdPathParam/order/invoice-title-prompt',
  async: withInit({ popover: { component: InvoiceTitlePrompt } })
}, {
  path: '/stores/:storeIdPathParam/order/receipt-carrier-id-prompt',
  async: withInit({ popover: { component: ReceiptCarrierIdPrompt } })
}, {
  path: '/stores/:storeIdPathParam/orders/:publicIdPathParam/line-pay-confirm',
  component: LinePayConfirmPage
}, {
  path: '/stores/:storeIdPathParam/orders/:publicIdPathParam/line-pay-failed',
  component: LinePayFailedPage
}, {
  path: '/stores/:storeIdPathParam/payment',
  async: withInit({ component: PaymentPage })
}, {
  path: '/stores/:storeIdPathParam/history',
  async: withInit({ component: HistoryPage })
}, {
  path: '(.*)',
  async: withInit({ component: NotFoundPage })
}]
